<div class="form-container__form-field flex flex-col w-full">
  <mat-icon *ngIf="icon" (click)="select.open()" svgIcon="{{icon}}" [color]="'primary'" class="icon cursor-pointer mb-4"></mat-icon>

  <mat-form-field [ngClass]="{'hidden-select': icon}">
    <mat-select placeholder="{{placeholder}}" multiple [formControl]="_control" panelClass="{{panelClass}}" [disableOptionCentering]="true" #select>
      <div cdkDropList (cdkDropListDropped)="drop($event)">
      <span *ngFor="let item of availableOptions" cdkDrag class="flex items-center justify-start px-4">
        <mat-icon cdkDragHandle [svgIcon]="'menu'" class="icon cursor-pointer"></mat-icon>
        <mat-option [matTooltip]="(i18nPath + item) | translate" [matTooltipDisabled]="((i18nPath + item) | translate)?.length <= 12" [value]="item" class="whitespace-nowrap">{{((i18nPath + item) | translate) | truncate: 12 }}</mat-option>
      </span>
      </div>
    </mat-select>
  </mat-form-field>
</div>
